export const LEARN_MORE = 'learnmore';
export const TRIAL = 'trial';
export const BUY = 'buy';
export const SIGNUP = 'signup';
export const TTS = 'tts';